import styles from "components/Form/Form.module.scss";

export const formConfig = {
  // User Fields
  "user.firstname": {
    title: "First Name",
    elementType: "input",
    elementConfig: {
      id: "user.firstname",
      type: "text",
      value: "",
      placeholder: "Russel",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: false,
    touched: false,
    error: { message: "First name is required" },
  },
  "user.lastname": {
    title: "Last Name",
    elementType: "input",
    elementConfig: {
      id: "user.lastname",
      type: "text",
      value: "",
      placeholder: "David",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: false,
    touched: false,
    error: { message: "Last name is required" },
  },
  "user.email": {
    title: "Email",
    elementType: "input",
    elementConfig: {
      id: "user.email",
      type: "email",
      value: "",
      placeholder: "user@example.com",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: false,
    touched: false,
    error: { message: "Email is required" },
  },
  "user.phone": {
    title: "Phone Number",
    elementType: "input",
    elementConfig: {
      id: "user.phone",
      type: "text",
      value: "",
      placeholder: "98759875",
      onblur: true,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: false,
    touched: false,
    error: { message: "Phone number is required" },
  },
  /*   "user.deviceId": {
      title: "Device ID",
      elementType: "input",
      elementConfig: {
        id: "user.deviceId",
        type: "text",
        value: "",
        autoComplete: "off",
        placeholder: "Search Device ID",
      },
      labelClasses: [styles.label],
      elementClasses: [styles.input],
      validation: { required: true },
      valid: false,
      touched: false,
      error: { message: "Device ID is required" },
    }, */
  /*  "user.password": {
     title: "Password",
     elementType: "input",
     elementConfig: {
       id: "user.password",
       type: "password",
       value: "",
       placeholder: "********",
     },
     labelClasses: [styles.label],
     elementClasses: [styles.input],
     validation: { required: true },
     valid: false,
     touched: false,
     error: { message: "Password is required" },
   }, */
  /*  "user.confirm_password": {
     title: "Confirm Password",
     elementType: "input",
     elementConfig: {
       id: "user.confirm_password",
       type: "password",
       value: "",
       placeholder: "********",
     },
     labelClasses: [styles.label],
     elementClasses: [styles.input],
     validation: { required: true },
     valid: false,
     touched: false,
     error: { message: "Confirm Password is required" },
   }, */

  // Account Fields
  "account.number": {
    title: "Account Number",
    elementType: "input",
    elementConfig: {
      id: "account.number",
      type: "text",
      value: "",
      "data-id": "",
      placeholder: "98759875",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: false,
    touched: false,
    error: { message: "Account number is required" },
  },
  "account.description": {
    title: "Account Description",
    elementType: "input",
    elementConfig: {
      id: "account.description",
      type: "text",
      value: "Main",
      placeholder: "e.g Main",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: false,
    touched: false,
    error: { message: "Account description is required" },
  },

  // Extension
  "extension.username": {
    title: "Extension Username",
    elementType: "input",
    elementConfig: {
      id: "extension.username",
      type: "text",
      value: "",
      placeholder: "98759875",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: false,
    touched: false,
    error: { message: "Extension username is required" },
  },

  // call_billing_account_id: {
  //   title: "Call Billing Account",
  //   elementType: "input",
  //   elementConfig: {
  //     id: "call_billing_account_id",
  //     type: "text",
  //     value: "",
  //     placeholder: "Search Call Billing Account",
  //   },
  //   labelClasses: [styles.label],
  //   elementClasses: [styles.input],
  //   validation: { required: false },
  //   valid: true,
  //   touched: false,
  //   dropdown: true,
  //   error: { message: "" },
  // },
  "call_billing_account.name": {
    title: "New Billing Account Name",
    elementType: "input",
    elementConfig: {
      id: "call_billing_account.name",
      type: "text",
      value: "Main",
      placeholder: "e.g Main",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: true,
    touched: false,
  },
  "call_billing_account.number": {
    title: "New Billing Account Number",
    elementType: "input",
    elementConfig: {
      id: "call_billing_account.number",
      type: "text",
      value: "",
      "data-id": "",
      placeholder: "Billing Account Number",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: true,
    touched: false,
  },
  "call_billing_account.description": {
    title: "Billing Account Description",
    elementType: "input",
    elementConfig: {
      id: "call_billing_account.description",
      type: "text",
      value: "Main",
      placeholder: "e.g Main",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: true,
    touched: false,
  },

  caller_id: {
    title: "Caller ID",
    elementType: "input",
    elementConfig: {
      id: "caller_id",
      type: "text",
      value: "",
      autoComplete: "off",
      placeholder: "Search Caller ID",
      onblur: true,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: true,
    touched: false,
    dropdown: true,
  },
  // "account_caller_id.callerid_name": {
  //   title: "Caller ID",
  //   elementType: "input",
  //   elementConfig: {
  //     id: "account_caller_id.callerid_name",
  //     type: "text",
  //     value: "",
  //     autoComplete: "off",
  //     placeholder: "e.g. 9875",
  //   },
  //   labelClasses: [styles.label],
  //   elementClasses: [styles.input],
  //   validation: { required: false },
  //   valid: true,
  //   touched: false,
  // },

  did_id: {
    title: "DID",
    elementType: "input",
    elementConfig: {
      id: "did_id",
      type: "text",
      value: "",
      autoComplete: "off",
      placeholder: "Search DID ID",
      onblur: true,
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: true,
    touched: false,
    dropdown: true,
  },
  // "did.number": {
  //   title: "New DID Number",
  //   elementType: "input",
  //   elementConfig: {
  //     id: "did.number",
  //     type: "text",
  //     value: "",
  //     autoComplete: "off",
  //     placeholder: "e.g. 9875",
  //   },
  //   labelClasses: [styles.label],
  //   elementClasses: [styles.input],
  //   validation: { required: false },
  //   valid: true,
  //   touched: false,
  // },
};
